import Link from "@/components/link";
import { Paragraph } from "@/components/ui/typography";

import { cn } from "@/lib/utils";

function OfflineCenterCard({ name, image, className, as = Link, ...props }) {
  const Component = as || "div";
  const CenterImage = image;

  return (
    <Component
      className={cn(
        "group flex items-center p-3 gap-x-4",
        "border border-grayscale-input rounded-lg shadow",
        "transition-all hover:shadow-xl hover:shadow-primary-weak/20 duration-300",
        className
      )}
      data-testid="offline-center-card"
      {...props}
    >
      <span
        className={cn(
          "flex items-center justify-center size-15 py-0.5 px-1.75 rounded-lg",
          "bg-grayscale-input text-grayscale-label",
          "group-hover:bg-primary group-hover:text-primary-foreground",
          "transition-colors duration-300"
        )}
        data-testid="offline-center-image"
      >
        <CenterImage viewBox="0 0 40 40" />
      </span>
      <Paragraph variant="b3" weight="sb">
        {name}
      </Paragraph>
    </Component>
  );
}

export default OfflineCenterCard;
